let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hdCSz")).then(() => parcelRequire('fCX8n'));